import localScaleManager from "../../../helpers/LocalScaleManager";

export class SeatTurnGlow {
  /***
   * @param scene {GameScene}
   * @param table {Table}
   */
  constructor(scene, table) {
    this.scene = scene;
    this.table = table;

    this.glow = this.scene.add
      .image(0, 0, this.scene.atlasTexture, "turn-glow")
      .setDepth(9)
      .setVisible(false);

    this.table.poolArray.push(this.glow);

    this.activateTween = null;
  }
  show(seat, duration) {
    if (this.activateTween) {
      this.activateTween.destroy();
      this.scene.tweens.remove(this.activateTween);
      this.activateTween = null;
    }
    this.positionControls(
      seat.displayWidth,
      seat.displayHeight,
      seat.x,
      seat.y,
      seat.isMyTable
    );
    // this.glow.setScale(this.glowInitScale);
    if (!this.glow.visible) this.glow.setVisible(true);
    if (this.glow.alpha !== 1) this.glow.setAlpha(1);

    this.activateTween = this.scene.add.tween({
      targets: this.glow,
      // duration: 400,
      duration: duration,
      ease: "Linear",
      // scale: "*= 0.85",
      // scale: "*= 0.95",
      // scale: "*= 0.1",
      alpha: 0,
      yoyo: true,
      loopDelay: duration / 2,
      loop: -1,
      // onStart: () => {
      //   console.warn("activate tween");
      // },
    });
  }
  hide() {
    if (this.glow.visible) this.glow.setVisible(false);
    if (this.activateTween) {
      this.activateTween.destroy();
      this.scene.tweens.remove(this.activateTween);
      this.activateTween = null;
    }
  }
  /***
   *
   * @param width {number} width of seat box
   * @param height {number} width of seat box
   * @param initX {number} seat box top left x
   * @param initY {number} seat box top left y
   */
  positionControls(width, height, initX, initY, isMyTable) {
    this.isMyTable = isMyTable;
    const activeBoxSize = isMyTable ? width * 1.5 : width * 2;
    localScaleManager.scaleSprite(
      this.glow,
      activeBoxSize,
      activeBoxSize,
      0,
      1,
      true
    );
    this.glow.setPosition(initX, initY - height * 0.8);
  }
  reposition(width, height, initX, initY) {
    this.glow.setPosition(initX, initY - height * 0.8);
  }
}
